import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'
import Typography from '../typography'

export const TableWrapper = styled('div')<{ theme?: TTheme }>`
    background-color: var(--color-greys-0);
    margin-bottom: 50px;

    .capitalize {
        text-transform: capitalize;
    }

    .severity-text {
        margin-left: 8px;
    }
`
export const HeaderText = styled(Typography)<{
    theme?: TTheme
    padding?: string
}>`
    color: var(--color-greys-600);
    margin: 12px 0;
    padding: ${({ padding }) => padding || '0'};
    div {
        justify-content: flex-start !important;
    }
`

export const Cell = styled('div')<{
    theme?: TTheme
    padding?: string
    cursor?: string
}>`
    min-height: 60px;
    flex: 1;
    margin: 0;
    width: 100%;
    display: flex;
    align-items: center;
    padding: ${({ padding }) => padding || '0'};
    cursor: ${({ cursor }) => cursor || 'pointer'};

    .severity-text {
        text-transform: capitalize;
        margin-left: 8px;
    }
`

export const NavigationTitle = styled(Typography)<{ theme?: TTheme }>`
    display: flex !important;
    gap: 16px;
    align-content: center;
    align-items: center;
    padding-left: 40px;
`

export const SubjectCell = styled('div')<{ theme?: TTheme }>`
    cursor: pointer;
    width: 100%;
    padding: 20px 0;

    .table-cell-text {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        white-space: normal;
        text-overflow: ellipsis;
        word-break: break-word;
    }
`
